import Collection from './collection'

export default class SportFilter extends Collection {
  _init() {
    this._isSportPicker = true
  }
}
